export enum RealTimeEventTypes {
  LocalControllerConnectionStatusChangedEvent,
  LocalControllerConfigurationAppliedEvent,
  ChargerConnectivityStatusChangedEvent,
  ChargerSimStatusChangedEvent,
  ConnectorStatusChangedEvent,
  LoadBalancingStatusChangedEvent,
  CommandUpdateEvent,
  SessionStatusUpdateEvent,
  DeviceStatusChangedEvent,
  ConnectorManuallyFaultedEvent
}
